
import { Component, Vue, Watch } from "vue-property-decorator";
// import { objAny, objStr, objNumber } from "../../common/common-interface";
import selectTime from "@/components/select-time/select-time.vue";
import { objAny } from "@/common/common-interface";
import { echartsJS } from "@/common/add-js";
import { getOptionList, optionKey } from "@/api/api-dict";
import piselectStation from "@/components/select-station/select-station.vue";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import PiExport from "@/components/pi-export/pi-export.vue";
import piSelectPile from "@/components/select-pile/select-pile.vue";
import { State } from "vuex-class";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import {
  getAlarmToday,
  getAlarmSummary,
  getAlarmQuery,
  getAlarmStaTop5,
  getAlarmPileTop5
} from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {
    "select-time": selectTime,
    "pi-select-pile": piSelectPile,
    piSelectOper,
    piSelectTableData,
    piselectStation,
    PiExport
  }
})
export default class AlarmEvent extends Vue {
  @State("sys") sys!: objAny;
  // private test: string = "light";
  @Watch("sys.winOnresize")
  getVisible(): void {
    this.resizeBox();
  }
  private isActivated = true;
  private privilegeVoObj: objAny = {};
  private time: objAny = {};
  private recoverTime: objAny = [];
  private alarmTime: objAny = [];

  // 1.严重 2.一般 3.紧急
  private alarmLevelList: objAny[] = [
    // {
    //   label: "一般",
    //   value: "1"
    // },
    // {
    //   label: "严重",
    //   value: "2"
    // },
    // {
    //   label: "紧急",
    //   value: "3"
    // }
  ];
  private deviceTypeList: objAny[] = [];
  // 1.设备故障告警 2.sim流量告警 3.订单费用异常告警
  private alarmTypeList: objAny[] = [
    // {
    //   label: "设备故障告警",
    //   value: "1"
    // },
    // {
    //   label: "sim流量告警",
    //   value: "2"
    // },
    // {
    //   label: "订单费用异常告警",
    //   value: "3"
    // }
  ];
  // 0.未恢复 1.已恢复
  private alarmStatusList: objAny[] = [
    // {
    //   label: "未恢复",
    //   value: "0"
    // },
    // {
    //   label: "已恢复",
    //   value: "1"
    // }
  ];

  private refNeed: objAny = {};
  private ruleInline = {};
  private initData!: objAny;
  private win: objAny = window;
  private chartsDiv: objAny = {
    chargeBoxOne: "",
    chargeBoxTwo: ""
  };
  // getVisible(newVal: string) {
  //   this.initEchart();
  // }
  private formInline: objAny = {
    alarmEndTime: "",
    alarmLevel: "",
    alarmStartTime: "",
    alarmStatus: "",
    alarmType: "",
    curPageFirst: "",
    deviceType: "",
    faultCode: "",
    globalOrder: "",
    // sortValues: [],
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    merchantPkId: "",
    objectId: "",
    oprPkId: "",
    pilePkId: "",
    recoverEndTime: "",
    recoverStartTime: "",
    staPkId: ""
  };

  private devTypeList = [];
  private loading = false;
  private total = 0;
  private tableList: objAny[] = [];
  private tableColumns: objAny[] = [];
  private searchShow = true;
  private allTableData: objAny[] = [
    {
      title: i18n.t("alarmEvent.stationName"),
      key: "staName",
      resizable: true,
      minWidth: 150
    },
    {
      title: i18n.t("alarmEvent.equipmentSn"),
      key: "sn",
      resizable: true,
      minWidth: 140
    },
    {
      title: i18n.t("alarmEvent.alarmType"),
      key: "alarmTypeName",
      resizable: true,
      minWidth: 120
    },
    {
      title: i18n.t("alarmEvent.alarmLevel"),
      key: "alarmLevelName",
      resizable: true,
      minWidth: 100
    },
    {
      title: i18n.t("alarmEvent.faultDesc"),
      key: "faultDesc",
      resizable: true,
      minWidth: 140
    },
    {
      title: i18n.t("alarmEvent.alarmTime"),
      key: "alarmTime",
      resizable: true,
      minWidth: 180
    },
    {
      title: i18n.t("alarmEvent.recoverTime"),
      key: "recoverTime",
      resizable: true,
      minWidth: 180
    },
    {
      title: i18n.t("alarmEvent.duration"),
      key: "duration",
      resizable: true,
      minWidth: 100
    },
    {
      title: i18n.t("alarmEvent.alarmStatus"),
      key: "alarmStatusName",
      resizable: true,
      minWidth: 100
    }
  ];
  private todayData: objAny[] = [];
  private todayAll = 0;
  private totalCount = 0;
  private alarmStatusStat: objAny[] = [];
  private alarmLevelStat: objAny[] = [];
  private alarmTypeStat: objAny[] = [];
  private alarmPileTop5: objAny[] = [];
  private alarmStaTop5: objAny[] = [];

  public tableChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    if (
      this.formInline.alarmStartTime == "" ||
      this.formInline.alarmEndTime == ""
    ) {
      this.$Message.error("告警时间不能为空 !");
      return;
    }
    this.loading = true;
    const params = this.formDataNull(this.formInline);
    const ret = await getAlarmQuery(params);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public formDataNull(data: objAny): objAny {
    const json: objAny = {};
    for (const i in data) {
      if (data[i] !== "" && data[i] !== undefined) {
        json[i] = data[i];
      }
    }
    return json;
  }
  public resizeBox(): void {
    if (this.chartsDiv.chargeBoxOne !== "" && this.isActivated) {
      this.chartsDiv.chargeBoxOne.resize();
    }
    if (this.chartsDiv.chargeBoxTwo !== "" && this.isActivated) {
      this.chartsDiv.chargeBoxTwo.resize();
    }
  }
  public timeChange(data: objAny): void {
    this.formInline.startTime = data.startTime;
    this.formInline.endTime = data.endTime;
    this.formInline.timeType = data.timeType;
  }

  private timeFnAlarmTime(value: string[]): void {
    this.formInline.alarmStartTime = value[0] ? value[0] + " 00:00:00" : "";
    this.formInline.alarmEndTime = value[1] ? value[1] + " 23:59:59" : "";
    this.queryAlarm();
    this.getAlarmPileTop5();
    this.getAlarmStaTop5();
    this.getAlarmSummary();
  }

  public recoverTimeChane(value: string[]): void {
    this.formInline.recoverStartTime = value[0] ? value[0] : "";
    this.formInline.recoverEndTime = value[1] ? value[1] : "";
  }

  public queryAlarm(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  async getAlarmSummary(): Promise<void> {
    this.alarmLevelStat = [];
    this.alarmTypeStat = [];

    const params = {
      startTime: this.$common.userDate(this.formInline.alarmStartTime),
      endTime: this.$common.userDate(this.formInline.alarmEndTime)
    };
    const ret = await getAlarmSummary(params);
    if (ret.status === this.$config.apiStatus) {
      this.totalCount = ret.data[0].totalCount;
      this.alarmTypeStat = ret.data[0].alarmTypeStat;
      this.alarmStatusStat = ret.data[0].alarmStatusStat;
      this.alarmLevelStat = ret.data[0].alarmLevelStat;
      this.$nextTick(() => {
        this.echartShowAll();
      });
    }
  }
  async getAlarmToday(): Promise<void> {
    const ret = await getAlarmToday();
    if (ret.status === this.$config.apiStatus) {
      let todayAll = 0;
      const list = ret.data;
      list.map((item: objAny) => {
        todayAll += item.value;
      });
      this.todayData = ret.data;
      this.todayAll = todayAll;
    }
  }
  async getAlarmPileTop5(): Promise<void> {
    const params = {
      startTime: this.formInline.alarmStartTime,
      endTime: this.formInline.alarmEndTime,
      oprPkId: this.formInline.oprPkId
    };
    const ret = await getAlarmPileTop5(params);
    if (ret.status === this.$config.apiStatus) {
      this.alarmPileTop5 = ret.data;
    }
  }
  async getAlarmStaTop5(): Promise<void> {
    const params = {
      startTime: this.formInline.alarmStartTime,
      endTime: this.formInline.alarmEndTime,
      oprPkId: this.formInline.oprPkId
    };
    const ret = await getAlarmStaTop5(params);
    if (ret.status === this.$config.apiStatus) {
      this.alarmStaTop5 = ret.data;
    }
  }
  async getOptionList(): Promise<void> {
    const ret = await getOptionList([
      optionKey.devTypeList,
      optionKey.alarmLevel,
      optionKey.alarmStatus,
      optionKey.alarmType
    ]); //请求字典
    this.devTypeList = ret[optionKey.devTypeList]; // 客户名称
    this.alarmLevelList = ret[optionKey.alarmLevel];
    this.alarmStatusList = ret[optionKey.alarmStatus];
    this.alarmTypeList = ret[optionKey.alarmType];
  }
  /**
   * 构建echart
   */
  async echartInit(): Promise<void> {
    await echartsJS();
  }
  async echartShowAll(): Promise<void> {
    this.echartShow(
      this.alarmLevelStat,
      this.refNeed.echartArlrmLevelList,
      "two",
      ["#F9DC76", "#F69F65", "#FF6464"]
    );
    this.echartShow(
      this.alarmTypeStat,
      this.refNeed.echartArlrmTypeList,
      "one",
      ["#5D7092", "#5AD8A6", "#3399FF"]
    );
    //
  }

  async echartShow(
    arr: objAny[],
    refList: objAny,
    type: string,
    color: string[]
  ): Promise<void> {
    const dataNeed: objAny[] = [];
    const arrList: objAny[] = [];
    arr.map((item: objAny) => {
      dataNeed.push({ value: item.value, name: item.name });
      arrList.push(item.name);
    });
    const option: objAny = {
      color: color,
      tooltip: {
        trigger: "item",
        formatter: "{b}: {c} ({d}%)"
      },
      legend: {
        orient: "",
        left: 0,
        top: 10,
        data: arrList
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "right"
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "12"
            }
          },
          labelLine: {
            show: false
          },
          data: dataNeed
        }
      ]
    };
    if (type === "one") {
      this.chartsDiv.chargeBoxOne = this.win.echarts.init(refList);
      this.chartsDiv.chargeBoxOne.clear();
      this.chartsDiv.chargeBoxOne.setOption(option);
    } else if (type === "two") {
      this.chartsDiv.chargeBoxTwo = this.win.echarts.init(refList);
      this.chartsDiv.chargeBoxTwo.clear();
      this.chartsDiv.chargeBoxTwo.setOption(option);
    }
  }
  /**
   * 设置当前一周时间
   */
  setWeekDay(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 6));
  }
  public queryOrder(row: objAny): void {
    this.$router.push(
      "/oper-manage/charge-order-list/charge-order-detail?orderNo=" +
        row.objectId
    );
  }
  public operChange(): void {
    this.getAlarmToday();
    this.queryAlarm();
    this.getAlarmPileTop5();
    this.getAlarmStaTop5();
  }
  mounted(): void {
    this.privilegeVoObj = this.$route.meta?.privilegeVoObj;
    const startTime =
      this.$common.userDate(this.setWeekDay(), "yyyy-MM-dd") + " 00:00:00";
    const endTime =
      this.$common.userDate(new Date(), "yyyy-MM-dd") + " 23:59:59";
    this.alarmTime = [startTime, endTime];
    this.formInline.alarmStartTime = startTime;
    this.formInline.alarmEndTime = endTime;
    this.$nextTick(async () => {
      await echartsJS();
      this.getOptionList();
      this.getAlarmToday();
      this.queryAlarm();
      this.getAlarmPileTop5();
      this.getAlarmStaTop5();

      this.refNeed.echartArlrmTypeList = this.$refs["echartArlrmTypeList"];
      this.refNeed.echartArlrmLevelList = this.$refs["echartArlrmLevelList"];
      this.echartInit();
    });
  }
  deactivated(): void {
    this.isActivated = false;
  }
  activated(): void {
    this.isActivated = true;
  }
}
